import { useMemo, useState } from 'react';

// Types.
import HostTarget from '../../../types/host/HostTarget';
import ChartPlotLine from '../../../types/ChartPlotLine';

// Constants.
import { CHART_DATA_TYPE, VIEW_MODE } from '../../Constants';

import ConditionalRender from '../../../helpers/ConditionalRender';

import TimeSeriesChart from '../../chart/echarts/TimeSeriesChart';
import { EChartTimeSeries } from '../../chart/echarts/types';
import HostChartCard from './HostChartCard';
import { toMetricSeries, useHostStatistic } from './useHostStatistic';

const MEMORY_METRICS = ['K used memory', 'K free memory', 'K buffer memory', 'K swap cache'];

function MemoryChart(props: { host: HostTarget, plotLines?: ChartPlotLine[] }) {
    const [mode, setMode] = useState<number>(VIEW_MODE.BASIC);
    const { loading, rows, timeSeries, peak: timePeak } = useHostStatistic(props.host, 'memoryutilisation');
    const basicSeries = useMemo<EChartTimeSeries[]>(() => [{
        name: 'Average Memory',
        chartType: 'line',
        data: timeSeries,
    }], [timeSeries]);

    const detailSeries = useMemo<EChartTimeSeries[]>(() => toMetricSeries(rows, MEMORY_METRICS), [rows]);

    return (
        <HostChartCard
            cardTitle="Average memory over time"
            chartTitle="Average Memory"
            collapseId="collapseMemoryCharts"
            peakLabel="Peak Average Memory"
            peakValue={timePeak}
            peakSuffix="%"
            mode={mode}
            onToggleMode={() => setMode(mode === VIEW_MODE.BASIC ? VIEW_MODE.DETAIL : VIEW_MODE.BASIC)}
            loading={loading}
        >
            <ConditionalRender if={mode === VIEW_MODE.BASIC}>
                <TimeSeriesChart series={basicSeries} tooltipType={CHART_DATA_TYPE.PERCENTAGE}
                                 plotLines={props.plotLines}/>
            </ConditionalRender>

            <ConditionalRender if={mode === VIEW_MODE.DETAIL}>
                <TimeSeriesChart series={detailSeries} tooltipType={CHART_DATA_TYPE.GENERIC}
                                 plotLines={props.plotLines} legend={true}/>
            </ConditionalRender>
        </HostChartCard>
    );
}

export default MemoryChart;
